// MUST match apps/api/src/common/types/platform.type.ts PLATFORMS — verified
// by a Phase 5 success criterion (grep that asserts set-wise and length-wise
// equality across the two files). Drift between the API enum and the
// dashboard enum surfaces as 400s on the create endpoint with no clear
// UI feedback. Add a 5th platform requires editing BOTH this file and
// apps/api/src/common/types/platform.type.ts, then a coordinated deploy.
export type Platform = 'ios' | 'android' | 'web' | 'harmonyos';
export const PLATFORMS: Platform[] = ['ios', 'android', 'web', 'harmonyos'];

// Maintenance rows apply to ONE platform only. To take all clients offline
// (backend outage), the operator must create 4 rows — one per platform.
// See docs/system-architecture.md "Operator runbook" section.
export interface MaintenanceWindow {
  id: string;
  game_id: string;
  platform: Platform;
  starts_at: string;
  ends_at: string;
  message: string;
  is_active: boolean;
  created_at: string;
}

export interface CreateMaintenanceInput {
  game_id: string;
  platform: Platform;
  starts_at: string;
  ends_at: string;
  message: string;
  is_active?: boolean;
}

// `platform` is INTENTIONALLY NOT in UpdateMaintenanceInput. The global
// API ValidationPipe has `forbidNonWhitelisted: true` (apps/api/src/main.ts:41),
// so PATCH bodies with `platform` return 400 with message
// "property platform should not exist". To change a window's platform,
// delete and recreate.
export interface UpdateMaintenanceInput {
  starts_at?: string;
  ends_at?: string;
  message?: string;
  is_active?: boolean;
}

export interface ListMaintenanceParams {
  game_id?: string;
  platform?: Platform;
}
